@if (show) {
    <mat-progress-bar [mode]="mode" [value]="progress ?? 0"></mat-progress-bar>
}
